import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/styles'
import { Header, Page } from 'components'
import { useSolicitacaoExameService } from 'hooks/useSolicitacaoExameService'

import { BackButton } from 'components/BackButton/BackButton'
import { Results } from './components'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
}))

export const SolicitacaoExames = (props) => {
  const { route } = props
  const solicitacaoExameService = useSolicitacaoExameService()
  const classes = useStyles()
  const idsState = useSelector((state) => state.idsState)

  const solicitacaoExame = useSelector((state) => state.solicitacaoExame.solicitacaoExame)

  useEffect(() => {
    solicitacaoExameService.listarSolicitacaoExameGlobal(idsState.idSolicitacaoExame)
    
  }, [])

  return (
    <Page className={classes.root} title={`${route.secao} - SIGEP`}>
      <Header titulo={`${route.secao}`} overline={route.secao} />
      {solicitacaoExame && <Results className={classes.results} dados={solicitacaoExame} />}
      <BackButton />
    </Page>
  )
}
